import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:true
};
const noCacheMeta = {
    auth: false
};

export default {
    path: '/schedule',
    name: 'schedule',
    redirect: {
        name: 'workPlanList'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/schedule/workPlanList',
            name: 'workPlanList',
            meta: {
                ...meta,
                title: '工作时段'
            },
            component: () => import('@/pages/schedule/workPlanList.vue')
        },
        {
            path: '/schedule/workPlanEdit/:id',
            name: 'workPlanEdit',
            meta: {
                ...noCacheMeta,
                title: '编辑工作时段'
            },
            component: () => import('@/pages/schedule/workPlanEdit.vue')
        },
        {
            path: '/schedule/workPlanEdit',
            name: 'workPlanAdd',
            meta: {
                ...noCacheMeta,
                title: '新增工作时段'
            },
            component: () => import('@/pages/schedule/workPlanEdit.vue')
        },
        {
            path: '/schedule/scheduleObjectList',
            name: 'scheduleObjectList',
            meta: {
                ...meta,
                title: '运行排班'
            },
            component: () => import('@/pages/schedule/scheduleObjectList.vue')
        },
        {
            path: '/schedule/scheduleObjectEdit/:id',
            name: 'scheduleObjectEdit',
            meta: {
                ...noCacheMeta,
                title: '编辑运行排班'
            },
            component: () => import('@/pages/schedule/scheduleObjectEdit.vue')
        },
        {
            path: '/schedule/scheduleObjectEdit',
            name: 'scheduleObjectAdd',
            meta: {
                ...noCacheMeta,
                title: '新增运行排班'
            },
            component: () => import('@/pages/schedule/scheduleObjectEdit.vue')
        },
    ]
};
